import Axios from "axios";

export default class Localizer {
    static cultureResources: Map<string, any> = new Map<string, any>();
    static defaultCulture: string = null;

    static async init(configuration: LocalizerConfiguration) {
        this.defaultCulture = configuration.defaultCulture;

        configuration.resourceCultures = configuration.resourceCultures ?? [configuration.defaultCulture];

        for (const resourceCulture of configuration.resourceCultures) {
            this.cultureResources.set(resourceCulture, (await Axios.get("/localization/resource/getresources", { params: { culture: resourceCulture, contexts: configuration.resourceContexts.join(",") } })).data);
        }
    }

    static get(name: string, ...values: any[]): string {
        return this.getByCulture(name, this.defaultCulture, values);
    }

    static getByCulture(name: string, culture: string, ...values: any[]): string {
        let placeHolder: string = name.split(".").pop();

        let resources: any = this.cultureResources.get(culture);

        if (!resources) {
            // Culture not found
            return placeHolder;
        }

        if (resources[name] === undefined) {
            // Resource not found
            this.trackMissingResource(name, window.location.href);
            return placeHolder;
        }

        if (resources[name] === null || resources[name] === '') {
            // Resource null or empty
            return placeHolder;
        }

        let resource: string = resources[name];

        for (var i = 0; i < values.length; i++) {
            resource = resource.replace(new RegExp("\\{" + i + "\\}", "g"), values[i]);
        }

        return resource;
    }

    static trackMissingResource(name: string, url: string) {
        Axios.post("/localization/resource/trackmissingresource", { name: name, url: url });
    }
}

export interface LocalizerConfiguration {
    defaultCulture: string;
    resourceContexts: string[];
    resourceCultures?: string[];
}